import { Outlet } from "react-router-dom";

const LearningProgramUserLayout = () => {
  return <Outlet />;
};

export default LearningProgramUserLayout;